module.exports = __webpack_public_path__ + "static/img/illus-03.f13e8da.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illus-03.webp
// module id = 104
// module chunks = 0